import { LinkVariant, Breakpoint, NavigationItem } from 'api/contentful/contentTypes.cloverdotcom';
import type { LinkVariantAndIcon } from 'components/NavBar/navBarTypes';
import { shouldDisplayLinkAsCustomIconForBreakpoint } from 'components/NavBar/navBarUtil';
import { useBreakpoints } from 'hooks/useBreakpoints';
import type { FlatEntry } from 'services/cms/flattenContentful';
import type { Asset } from 'services/cms/typesUtil';

export function useNavBarUtilItems() {
  const { browser } = useBreakpoints();
  const isMobile = browser.is.mobile;
  const isTablet = browser.is.tablet;
  const isDesktopOrLarger = browser.is.desktop;

  const categorizeUtilItems = (utilItems: LinkVariantAndIcon[]) => {
    const isCustomIconItem = (customIcon?: Asset, customIconAppearsIn?: readonly Breakpoint[]) =>
      customIcon &&
      shouldDisplayLinkAsCustomIconForBreakpoint(customIconAppearsIn, isMobile, isTablet, isDesktopOrLarger);

    const isButtonUtilItem = (variant?: LinkVariant) =>
      variant && [LinkVariant.PRIMARY, LinkVariant.SECONDARY].includes(variant);

    const isCustomIconAndButtonUtilItem = (
      customIcon?: Asset,
      customIconAppearsIn?: readonly Breakpoint[],
      variant?: LinkVariant,
    ) => isMobile && isCustomIconItem(customIcon, customIconAppearsIn) && isButtonUtilItem(variant);

    return utilItems.reduce(
      (acc, item) => {
        if (!item) return acc;

        if (isCustomIconAndButtonUtilItem(item.customIcon, item.customIconAppearsIn, item.variant)) {
          acc.customIconUtilItems.push(item);
          acc.buttonUtilItems.push(item);
        } else if (isCustomIconItem(item.customIcon, item.customIconAppearsIn)) {
          acc.customIconUtilItems.push(item);
        } else if (item.materialIcon) {
          acc.materialIconUtilItems.push(item);
        } else if (isButtonUtilItem(item.variant)) {
          acc.buttonUtilItems.push(item);
        } else {
          acc.textUtilItems.push(item);
        }
        return acc;
      },
      {
        customIconUtilItems: [] as Array<FlatEntry<NavigationItem>>,
        buttonUtilItems: [] as Array<FlatEntry<NavigationItem>>,
        textUtilItems: [] as Array<FlatEntry<NavigationItem>>,
        materialIconUtilItems: [] as Array<FlatEntry<NavigationItem>>,
      },
    );
  };

  return {
    categorizeUtilItems,
  };
}
